export interface Theme {
  bg: string; bg2: string; bg3: string
  fg: string; fg2: string; fg3: string
  accent: string; accentFg: string
  border: string; borderStrong: string
  cardBg: string; cardShadow: string
  navBg: string; isDark: boolean
}

export const LIGHT: Theme = {
  bg:           "#ffffff",
  bg2:          "#f5f5f7",
  bg3:          "#e8e8ed",
  fg:           "#1d1d1f",
  fg2:          "#6e6e73",
  fg3:          "#aeaeb2",
  accent:       "#0071e3",
  accentFg:     "#ffffff",
  border:       "rgba(0,0,0,0.08)",
  borderStrong: "rgba(0,0,0,0.16)",
  cardBg:       "#ffffff",
  cardShadow:   "0 2px 24px rgba(0,0,0,0.07), 0 1px 4px rgba(0,0,0,0.04)",
  navBg:        "rgba(255,255,255,0.85)",
  isDark:       false,
}

export const DARK: Theme = {
  bg:           "#000000",
  bg2:          "#111113",
  bg3:          "#1c1c1e",
  fg:           "#f5f5f7",
  fg2:          "#b0b0b5",
  fg3:          "#96969b",
  accent:       "#2997ff",
  accentFg:     "#ffffff",
  border:       "rgba(255,255,255,0.09)",
  borderStrong: "rgba(255,255,255,0.18)",
  cardBg:       "#1c1c1e",
  cardShadow:   "0 2px 24px rgba(0,0,0,0.6), 0 1px 4px rgba(0,0,0,0.35)",
  navBg:        "rgba(0,0,0,0.85)",
  isDark:       true,
}
